export default __webpack_public_path__ + "static/media/logo.eeadac0e.png";